import React, { useEffect, useState } from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import ObcApp from "./pages/ObcApp";
import { ObcLogin } from "./pages/ObcLogin";
import ObcLanding from "./pages/ObcLanding";
import ObcSignup from "./pages/ObcSignup";
import ObcOnboardingSteps from "./components/Onboarding/ObcOnboardingSteps";
import SendEmail from "./pages/SendEmail";
import IosInstallGuide from "./utils/IOSInstallPrompt";

function App() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallBtn, setShowInstallBtn] = useState(false);
  const [isIos, setIsIos] = useState(false);
  const [showIosGuide, setShowIosGuide] = useState(false);

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isOnIos = /iphone|ipad|ipod/.test(userAgent);
    const isInStandaloneMode =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone;

    setIsIos(isOnIos);

    // If iOS and not already installed, show install button
    if (isOnIos && !isInStandaloneMode) {
      setShowInstallBtn(true);
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);

      // If Android and not installed
      if (!isOnIos && !isInStandaloneMode) {
        setShowInstallBtn(true);
      }
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const handleInstallClick = () => {
    if (isIos) {
      setShowIosGuide(true);
    } else if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        setDeferredPrompt(null);
        setShowInstallBtn(false);
      });
    }
  };

  return (
    <>
      {showIosGuide && (
        <IosInstallGuide onClose={() => setShowIosGuide(false)} />
      )}

      {/* Install button for both platforms */}
      {showInstallBtn && (
        <div className="fixed bottom-4 right-4 z-[1000]">
          <button
            onClick={handleInstallClick}
            className="px-4 py-3 text-sm bg-primary-500 text-white rounded-lg shadow-md hover:bg-primary-500 transition"
          >
            Install App
          </button>
        </div>
      )}

      <Router>
        <Routes>
          <Route path="/ground/*" element={<ObcApp />} />
          <Route path="/home/*" element={<ObcApp />} />
          <Route path="/" element={<ObcLanding />} />
          <Route path="/*" element={<ObcApp />} />
          <Route path="/onboarding/*" element={<ObcOnboardingSteps />} />
          <Route path="/login" element={<ObcLogin />} />
          <Route path="/signup" element={<ObcSignup />} />
          <Route path="/send-email" element={<SendEmail />} />
        </Routes>
      </Router>
    </>
  );
}

//comment to test pipeline

export default App;
